import {
	WeaTools
} from 'ecCom'

export const getForgotPasswordForm = (params) => WeaTools.callApi('/api/hrm/forgotPassword/getForgotPasswordForm', 'POST', params)

export const forgotPasswordToNext = (params) => WeaTools.callApi('/api/hrm/forgotPassword/forgotPasswordToNext', 'POST', params)

export const passwordQuestionForm = (params) => WeaTools.callApi('/api/hrm/forgotPassword/passwordQuestionForm', 'POST', params)

export const passwordQuestionToNext = (params) => WeaTools.callApi('/api/hrm/forgotPassword/passwordQuestionToNext', 'POST', params)

export const resetPasswordForm = (params) => WeaTools.callApi('/api/hrm/forgotPassword/resetPasswordForm', 'POST', params)

export const saveResetPassword = (params) => WeaTools.callApi('/api/hrm/forgotPassword/saveResetPassword', 'POST', params)

export const confirmPhoneCodeForm = (params) => WeaTools.callApi('/api/hrm/forgotPassword/confirmPhoneCodeForm', 'POST', params)

export const confirmEmailCodeForm = (params) => WeaTools.callApi('/api/hrm/forgotPassword/confirmEmailCodeForm', 'POST', params)

export const confirmPhoneCodeToNext = (params) => WeaTools.callApi('/api/hrm/forgotPassword/confirmPhoneCodeToNext', 'POST', params)

export const confirmEmailCodeToNext = (params) => WeaTools.callApi('/api/hrm/forgotPassword/confirmEmailCodeToNext', 'POST', params)

export const forgotPasswordCheckMsg = (params) => WeaTools.callApi('/api/hrm/forgotPassword/forgotPasswordCheckMsg', 'POST', params)



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/forgetPassword.js